"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = HomeCategoryBanner;
const react_1 = __importDefault(require("react"));
const SharedDuplexBanner_1 = __importDefault(require("../SharedDuplexBanner/SharedDuplexBanner"));
const SharedImageBanner_1 = __importDefault(require("../SharedImageBanner/SharedImageBanner"));
const SharedPremiumImageBanner_1 = __importDefault(require("../SharedPremiumImageBanner/SharedPremiumImageBanner"));
const HomeCategoryBanner_module_scss_1 = __importDefault(require("./HomeCategoryBanner.module.scss"));
function HomeCategoryBanner({ data, testId, }) {
    let Banner = null;
    if (data.designType === "largeDuplex" ||
        data.designType === "LargeDuplex" ||
        data.designType === "smallDuplex" ||
        data.designType === "SmallDuplex") {
        Banner = SharedDuplexBanner_1.default;
    }
    if (data.designType === "smallImage" ||
        data.designType === "SmallImage" ||
        data.designType === "largeImage" ||
        data.designType === "LargeImage") {
        Banner = SharedImageBanner_1.default;
    }
    if (data.designType === "premiumSmallImage" ||
        data.designType === "PremiumSmallImage") {
        Banner = SharedPremiumImageBanner_1.default;
    }
    return Banner ? (react_1.default.createElement("div", { className: HomeCategoryBanner_module_scss_1.default.container },
        react_1.default.createElement(Banner, Object.assign({}, data, { testId: testId })))) : null;
}
